import { UserProfileDetails } from 'components/profile/UserProfileDetails/UserProfileDetails';

export function UserProfile() {
  return <UserProfileDetails />;
}
